import { render, staticRenderFns } from "./FormControlModulestructureNumRows.vue?vue&type=template&id=05de6491&scoped=true"
import script from "./FormControlModulestructureNumRows.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureNumRows.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlModulestructureNumRows.vue?vue&type=style&index=0&id=05de6491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de6491",
  null
  
)

export default component.exports